import { itemById } from '@penalty-cup/shared';
import type { CSSProperties } from 'react';

/** Празднование своего гола (магазин): конфетти, салют или молния. */
export function Celebration({ itemId }: { itemId: string | undefined }) {
  const item = itemById(itemId) ?? itemById('celebration-confetti')!;
  const kind = item.id.replace('celebration-', '');
  const n = kind === 'fireworks' ? 24 : 16;
  return (
    <div className={`celebrate celebrate--${kind}`} aria-hidden="true" data-testid="celebration">
      {Array.from({ length: n }, (_, i) => {
        const angle = (i / n) * Math.PI * 2;
        const dist = kind === 'fireworks' ? 140 : 90 + (i % 3) * 30;
        return (
          <i
            key={i}
            style={
              {
                background: item.colors[i % 2],
                '--dx': `${Math.round(Math.cos(angle) * dist)}px`,
                '--dy': `${Math.round(Math.sin(angle) * dist + (kind === 'confetti' ? 60 : 0))}px`,
                borderRadius: kind === 'fireworks' ? '50%' : '2px',
              } as CSSProperties
            }
          />
        );
      })}
    </div>
  );
}
